import { render, staticRenderFns } from "./yiyi.vue?vue&type=template&id=0503398a&scoped=true&"
import script from "./yiyi.vue?vue&type=script&lang=js&"
export * from "./yiyi.vue?vue&type=script&lang=js&"
import style0 from "./yiyi.vue?vue&type=style&index=0&id=0503398a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503398a",
  null
  
)

export default component.exports